<template>
	<div class="title-bar">

		<div>
			<div class="title">
				<h2 v-html="title"></h2>
				<div v-if="total">({{ total }} deals)</div>
			</div>
		</div>
		
		<div>
			<Search />
		</div>

	</div>
</template>

<script>
import Search from './Search.vue';

//
export default {
	name: "TitleBar",
	components: {
		Search
	},
	props: {
		title: {
			type: String,
			default: "Deals"
		},
		totalDeals: {
			default: 0
		}
	},
	data: function() {
		return {}
	},
	computed: {
		total() {
			try {
				return ( this.totalDeals >= 10000 ) ? "Over 10,000" : this.totalDeals;
			}catch(e) {
				return 0;
			}
		}
	},
	methods: {}
};
</script>

<style lang="scss">
.title-bar {
	position: relative;
	border-style: solid;
	border-width: 1px;
	border-color: rgb(147, 146, 146);
	background-color: rgb(255, 255, 255);
	box-shadow: 0px 0px 6.88px 1.12px rgba(1, 1, 1, 0.16);
	margin-bottom: 40px;
	padding: 10px 20px;
	display: flex;
	justify-content: space-between;
	align-items: center;

	>* {
		display: flex;
		justify-content: space-between;

		&:last-child {
			justify-content: flex-end;
		}
	}

	.title {
		font-size: 15px;
		font-weight: 100;
		text-transform: capitalize;

		h2 {
			margin-right: 10px;
			font-size: 28px;
		}
	}

	//
	.search-deals {
		display: none;
		input[type=text] {
			width: 220px;
			border: #dfdfdf 2px solid;
		}
		.fa-search {
			color: #858585;
		}
	}

	@media ( min-width: 480px ) {
		.title {
			display: flex;
			align-items: baseline;
		}
	}
}
</style>